<div style="width: 50rem">
    <div class="modal-header">
        <img class="modal-close" (click)="dismissModal()" alt="Close modal">
        <h1 class="modal-title text-center" style="overflow-wrap: anywhere;">{{ parameterName }}</h1>
    </div>
    <div class="modal-body"  style="word-wrap: break-word;">
        <h1>{{ displayValue }}</h1>
    </div>
</div>
